import React from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import AuthPageLayout from "../../components/layout/AuthPageLayout";
import { images } from "../../assets";
import {
  ApprovedContainer,
  ApprovedIcon,
  ApprovedTitle,
  ApprovedSubtitle,
} from "./TreatmentPlanApprovedPage.styled";

const TreatmentPlanApprovedPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <AuthPageLayout>
      <ApprovedContainer>
        <ApprovedIcon>
          <Box
            component="img"
            src={images.addAppointment}
            alt={t("treatmentPlanApproved.iconAlt")}
            sx={{
              width: { xs: "150px", sm: "200px" },
              height: "auto",
            }}
          />
        </ApprovedIcon>

        <ApprovedTitle>{t("treatmentPlanApproved.title")}</ApprovedTitle>

        <ApprovedSubtitle>
          {t("treatmentPlanApproved.subtitle")}
        </ApprovedSubtitle>
      </ApprovedContainer>
    </AuthPageLayout>
  );
};

export default TreatmentPlanApprovedPage;
